import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { Material } from './material.model';
import { DefaultService } from 'src/app/core/framework/default-service';
import { ProdutoFilter } from '../produto/produto.filter';

export interface MaterialFilter extends ProdutoFilter {
  descartavel?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MaterialService extends DefaultService<Material> {

    constructor(
      public httpClient: HttpClient,
      public errorHandler: ErrorHandlerService
    ) {
        super(
          httpClient,
          errorHandler,
          '/api/produto/v1/materiais'
        );
    }

}
